import React from "react";
import { HammerIcon } from "lucide-react";
export function Logo({
  small = false
}: {
  small?: boolean;
}) {
  return <div className="flex flex-col items-center" data-id="element-96" data-mp="8u4ralcbprnc">
      <span className={`flex items-center justify-center rounded-full bg-brand text-white ${small ? "h-9 w-9" : "h-16 w-16"}`} data-id="element-97" data-mp="8uwb6ywk60xs">
        <HammerIcon className={small ? "h-5 w-5" : "h-8 w-8"} aria-hidden="true" data-id="element-98" data-mp="3v84lsvs388d5" />
      </span>
      <span className={`font-heading font-bold tracking-tight ${small ? "mt-1 text-lg" : "mt-2 text-3xl md:text-4xl"}`} data-id="element-99" data-mp="mscngr1jcoxg">
        <span className="text-brand" data-id="element-100" data-mp="rqw9ssk1k2qc">Wood</span>
        <span className="text-ink" data-id="element-101" data-mp="rpl58qiruqy6">Forge</span>
        <span className="text-ink" data-id="element-102" data-mp="dr4pka2xlq3w"> DI</span>
        <span className="text-brand" data-id="element-103" data-mp="duirjh7onxat">Y</span>
      </span>
    </div>;
}